import { Controller } from "@hotwired/stimulus"

// Schedule only: this never fetches status, claims "live now", or controls playback.
export default class extends Controller {
  static targets = ["countdown"]
  static values = { nextLiveShow: String, window: Number }

  connect() {
    this.startsAt = Date.parse(this.nextLiveShowValue)
    this.update()
  }

  disconnect() {
    clearTimeout(this.timer)
  }

  update() {
    clearTimeout(this.timer)
    const remaining = this.startsAt - Date.now()
    this.element.hidden = remaining <= 0 || remaining > this.windowValue
    if (remaining <= 0) return

    if (!this.element.hidden) {
      const minutes = Math.ceil(remaining / 60000)
      const countdown = `${Math.floor(minutes / 60)}h ${minutes % 60}m`
      this.countdownTargets.forEach(target => { target.textContent = countdown })
    }

    const delay = remaining > this.windowValue
      ? remaining - this.windowValue
      : this.countdownTargets.length ? Math.min(remaining, remaining % 60000 || 60000) : remaining
    this.timer = setTimeout(() => this.update(), delay)
  }
}
